import React, { useState } from 'react';
import DashboardLayout from "../DashboardLayout";
import { BacktestView } from '../../components/BacktestView';
import PerformanceView from './PerformanceView';
import BuyLiveAuditView from './BuyLiveAuditView';
import AuditWorkflow from './AuditWorkflow';
import AdaptiveDashboardView from './AdaptiveDashboardView';
import AlphaDashboardView from './AlphaDashboard/AlphaDashboardView';

const Audit = () => {
    const [activeTab, setActiveTab] = useState('backtest');
    const [adaptiveMode, setAdaptiveMode] = useState('optimus'); // 'optimus' | 'alpha'

    return (
        <DashboardLayout>
            <div className="flex flex-col h-screen w-full bg-[#0f1116] text-gray-100 overflow-hidden">
                {/* Tabs Header */}
                <div className="flex items-center justify-between border-b border-gray-800 bg-[#1a1d29] shrink-0 pr-6">
                    <div className="flex">
                        <button
                            className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer ${
                                activeTab === 'backtest'
                                    ? 'border-b-2 border-blue-500 text-blue-400'
                                    : 'text-gray-400 hover:text-gray-200'
                            }`}
                            onClick={() => setActiveTab('backtest')}
                        >
                            Backtest
                        </button>
                        <button
                            className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer ${
                                activeTab === 'details'
                                    ? 'border-b-2 border-blue-500 text-blue-400'
                                    : 'text-gray-400 hover:text-gray-200'
                            }`}
                            onClick={() => setActiveTab('details')}
                        >
                            Audit
                        </button>
                        <button
                            className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer ${
                                activeTab === 'performance'
                                    ? 'border-b-2 border-blue-500 text-blue-400'
                                    : 'text-gray-400 hover:text-gray-200'
                            }`}
                            onClick={() => setActiveTab('performance')}
                        >
                            Performance
                        </button>
                        <button
                            className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer ${
                                activeTab === 'buy_live_audit'
                                    ? 'border-b-2 border-blue-500 text-blue-400'
                                    : 'text-gray-400 hover:text-gray-200'
                            }`}
                            onClick={() => setActiveTab('buy_live_audit')}
                        >
                            Buy Live Audit
                        </button>
                        <button
                            className={`px-6 py-4 text-sm font-medium transition-colors cursor-pointer ${
                                activeTab === 'adaptive_dashboard'
                                    ? 'border-b-2 border-blue-500 text-blue-400'
                                    : 'text-gray-400 hover:text-gray-200'
                            }`}
                            onClick={() => setActiveTab('adaptive_dashboard')}
                        >
                            Adaptive Dashboard
                        </button>
                    </div>

                    {/* Mode Toggle when inside Adaptive Dashboard */}
                    {activeTab === 'adaptive_dashboard' && (
                        <div className="flex items-center gap-1 bg-[#0f1116] p-1 rounded-lg border border-gray-800">
                            <button
                                className={`px-4 py-1.5 text-xs font-semibold rounded-md transition-all cursor-pointer ${
                                    adaptiveMode === 'optimus'
                                        ? 'bg-blue-600 text-white shadow-md'
                                        : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800/50'
                                }`}
                                onClick={() => setAdaptiveMode('optimus')}
                            >
                                Optimus
                            </button>
                            <button
                                className={`px-4 py-1.5 text-xs font-semibold rounded-md transition-all cursor-pointer ${
                                    adaptiveMode === 'alpha'
                                        ? 'bg-amber-600 text-white shadow-md'
                                        : 'text-gray-400 hover:text-gray-200 hover:bg-gray-800/50'
                                }`}
                                onClick={() => setAdaptiveMode('alpha')}
                            >
                                Alpha
                            </button>
                        </div>
                    )}
                </div>

                {/* Content Area */}
                <div className="flex-1 overflow-hidden relative p-6">
                    {activeTab === 'backtest' ? (
                        <div className="h-full rounded-xl overflow-hidden border border-gray-800">
                            <BacktestView />
                        </div>
                    ) : activeTab === 'details' ? (
                        <AuditWorkflow />
                    ) : activeTab === 'buy_live_audit' ? (
                        <BuyLiveAuditView />
                    ) : activeTab === 'adaptive_dashboard' ? (
                        adaptiveMode === 'optimus' ? (
                            <AdaptiveDashboardView />
                        ) : (
                            <AlphaDashboardView />
                        )
                    ) : (
                        <PerformanceView />
                    )}
                </div>
            </div>
        </DashboardLayout>
    );
};

export default Audit;
